import React, { useEffect, useState } from 'react'
import { Card, Col, Container, Row } from 'react-bootstrap'
import withAuth from '../components/authHOC'
import { useSelector } from 'react-redux'
import { IInstitution } from '../factory/interfaces'
import { Button, Form, Input, Spin } from 'antd'
import { IoMdArrowDropright } from 'react-icons/io'
import { CloseOutlined, EditOutlined, SaveOutlined } from '@ant-design/icons'
import axios from 'axios'
import { AUTH_URL } from '../constants'
import { notify_success, toastStyle } from './LoginPage'
import { notify_error } from '../components/Toaster'
import { useDispatch } from 'react-redux'
import { getMetaData } from '../actions/metaActions'

const InstitutionPage = () => {
    const [institution, setInstitution]= useState<IInstitution>()
    const [editable, setEditable]= useState(false)
    const [editingInsitituion, setEditingInstitution] = useState(false)
    const metadata = useSelector((state: any) => state.metadata)
    const [form] = Form.useForm()

    const dispatch = useDispatch()

    const updateInstitution = async()=>{

      setEditingInstitution(true)

      try {
        const new_institution_body ={
          name: form.getFieldValue('name'),
          address: form.getFieldValue('address'),
          phone: form.getFieldValue('phone'),
          email: form.getFieldValue('email'),
        }

        const response = await axios.patch(`${AUTH_URL}/meta/institution/${institution?._id}`, new_institution_body, {withCredentials: true})
      setEditingInstitution(false)

      if(response.data.success){
        notify_success(`${response.data.message}`, toastStyle)
        dispatch(getMetaData() as any)

      }
        
      } catch (error: any) {
        notify_error(`${error.message}`, toastStyle)
        setEditingInstitution(false)

      }
    }


 useEffect(() => {
    if (metadata?.data?.success) {
        setInstitution(metadata.data.meta_data.institution)
    }
  }, [metadata])

  return (
    <Container fluid id='users-container'>
    <Row>
     <Col>
     {

        institution ?
         <Card className='p-3 rounded-0'>
          <Form
          layout="horizontal"
          form={form}
          onFinish={updateInstitution}
          >
          <Card className='p-3 rounded-0'>
          
          <Row>
             <Form.Item 
            label="Name"
            name="name"
            initialValue={institution?.name}
            >
            <Input readOnly={!editable}></Input>
          </Form.Item>
          
          </Row>
       
           <Form.Item 
            label="Address"
            name="address"
            initialValue={institution?.address}
            >
            <Input readOnly={!editable}/>
          </Form.Item>
          <Form.Item 
            label="Phone"
            name="phone"
            initialValue={institution?.phone}
            >
            <Input readOnly={!editable}/>
            
          </Form.Item>
          <Form.Item 
            label="Email"
            name="email"
            initialValue={institution?.email}
            >
            <Input readOnly={!editable}/>
            
          </Form.Item>
          <Col>
          </Col>
          <Col>
         
          {editable ?
          <>
          <Button 
           htmlType='submit' 
           loading={editingInsitituion} 
           className='small rounded-0 text-uppercase' 
           key="save-changes" 
           type="primary" 
           >
                    <span><SaveOutlined /></span>
                       { editingInsitituion ?
                       
                       'Saving Changes...':
                       'Save Changes'

                       }
                    </Button>
                    <Button className='small mx-3 rounded-0 text-uppercase' key="cancel" onClick={()=>setEditable(false)}>
                     <CloseOutlined />   Cancel editing
                    </Button>
          
          </>
          :
         <Button onClick={()=>setEditable(true)} type='primary' className='text-uppercase small rounded-0'>
          <span><EditOutlined /></span> Edit
          </Button>

          }
          </Col>
         </Card>
        </Form>
        
     </Card>
     : 

     <Spin size='large'></Spin>


     }
    
     
     </Col>

    </Row>
    
    </Container>
  )
}

export default withAuth (InstitutionPage, ['admin'])